import React from 'react';

const CALCULATOR_TIERS = [
  { label: '< 100', recommendation: 'free', planLabel: 'Free' },
  { label: '100 - 3K', recommendation: 'light', planLabel: 'Light' },
  { label: '3K - 15K', recommendation: 'starter', planLabel: 'Starter' },
  { label: '15K - 50K', recommendation: 'pro', planLabel: 'Pro' },
  { label: '50K - 100K', recommendation: 'pro', planLabel: 'Pro' },
  { label: '100K - 200K', recommendation: 'max', planLabel: 'Max' },
  { label: '200K+', recommendation: 'max', planLabel: 'Max' },
];

const UsageCalculator = ({ value, onChange, onSelectPlan }) => {
  const tier = CALCULATOR_TIERS[value];

  return (
    <div className="rounded-xl border border-gray-200 dark:border-gray-700/30 bg-gradient-to-br from-gray-50 dark:from-gray-900/60 to-gray-100 dark:to-gray-800/40 p-8 text-center">
      <h3 className="text-xl font-bold text-gray-800 dark:text-gray-100 mb-2">Not sure which plan is right for you?</h3>
      <p className="text-sm text-gray-500 dark:text-gray-400 mb-6">
        How many pages do you need to collect per month?
      </p>

      <div className="max-w-md mx-auto">
        <style>{`
          .calc-slider::-webkit-slider-thumb {
            -webkit-appearance: none;
            width: 22px;
            height: 22px;
            border-radius: 50%;
            background: linear-gradient(135deg, #60a5fa, #22d3ee, #c084fc);
            cursor: pointer;
            border: 2px solid white;
            box-shadow: 0 0 10px rgba(34, 211, 238, 0.4), 0 2px 4px rgba(0, 0, 0, 0.1);
            margin-top: -7px;
          }
          .calc-slider::-moz-range-thumb {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: linear-gradient(135deg, #60a5fa, #22d3ee, #c084fc);
            cursor: pointer;
            border: 2px solid white;
            box-shadow: 0 0 10px rgba(34, 211, 238, 0.4), 0 2px 4px rgba(0, 0, 0, 0.1);
          }
          .calc-slider::-webkit-slider-runnable-track {
            background: transparent;
            height: 8px;
            border-radius: 9999px;
            cursor: pointer;
          }
          .calc-slider::-moz-range-track {
            background: transparent;
            height: 8px;
            border-radius: 9999px;
            cursor: pointer;
          }
        `}</style>

        <div className="relative">
          {/* Track background */}
          <div className="absolute inset-x-0 h-2 top-1/2 -translate-y-1/2 rounded-full bg-gray-200 dark:bg-gray-700" />
          {/* Gradient fill */}
          <div
            className="absolute h-2 top-1/2 -translate-y-1/2 rounded-full bg-gradient-to-r from-blue-500 via-cyan-500 to-cyan-400 transition-all duration-150"
            style={{ width: `calc(11px + (100% - 22px) * ${value / (CALCULATOR_TIERS.length - 1)})` }}
          />
          <input
            type="range"
            min={0}
            max={CALCULATOR_TIERS.length - 1}
            value={value}
            onChange={(e) => onChange(Number(e.target.value))}
            className="calc-slider relative w-full h-[22px] m-0 p-0 rounded-full appearance-none cursor-pointer bg-transparent z-10"
          />
        </div>

        <div className="flex justify-between mt-2 px-1">
          {CALCULATOR_TIERS.map((t, i) => (
            <span
              key={i}
              className={`text-[11px] transition-colors ${
                value === i ? 'text-cyan-500 dark:text-cyan-400 font-semibold' : 'text-gray-400 dark:text-gray-600'
              }`}
            >
              {t.label}
            </span>
          ))}
        </div>
      </div>

      {/* Recommendation with CTA */}
      <div className="mt-6">
        <div className="inline-flex flex-col items-center gap-3 px-10 py-5 rounded-2xl border border-gray-200/60 dark:border-gray-700/20 bg-white/60 dark:bg-gray-800/30">
          <div className="text-center">
            <p className="text-xs text-gray-500 dark:text-gray-400 mb-1 uppercase tracking-wide font-medium">
              Perfect plan for you
            </p>
            <p className="text-3xl font-black bg-gradient-to-r from-blue-500 via-cyan-500 to-purple-500 bg-clip-text text-transparent">
              {tier.planLabel}
            </p>
          </div>

          {tier.recommendation !== 'free' && onSelectPlan && (
            <button
              onClick={() => onSelectPlan(tier.recommendation)}
              className="px-6 py-2.5 rounded-lg font-semibold text-sm bg-gradient-to-r from-blue-500 via-cyan-500 to-purple-500 hover:from-blue-600 hover:via-cyan-600 hover:to-purple-600 text-white shadow-glow-cyan hover:shadow-glow-md transition-all duration-300 hover:scale-105 transform"
            >
              Get {tier.planLabel} Now &rarr;
            </button>
          )}
        </div>

      </div>
    </div>
  );
};

export { CALCULATOR_TIERS };
export default UsageCalculator;
